module.exports = "/images/ga.svg?8938b80ebf5038ba419bb1670f91b655";